<template>
  <div>
    <p class="heading ff-montserrat-bol tx-30 mb-4">Características</p>

    <div class="grid-cx justify-content-around flex-wrap">
      <template v-for="(spec, index) in computedSpecs" >
        <div class="p-4" v-if="spec.value !== 'false'" :key="index">
          <div class="border-b-cx">
            <p class="ff-montserrat-medium"></p>
            <span class="my-3" v-if="spec.value == 'true' || spec.value == true">
              {{ $t(spec.name) }}
            </span>
            <span class="my-3" v-else-if="spec.value != 'false'">
              {{ `${ $t(spec.name) } - ${ spec.value }` }}
            </span>
          </div>
        </div>
      </template>
    </div>

    <button
      v-if="btnFlag"
      @click="showMore"
      class="btn btn--green-ad py-2 px-5 ml-2 m-2"
    >
      VER MÁS
    </button>
    <button
      v-show="!btnFlag"
      @click="showLess"
      class="btn btn--green-ad py-2 px-5 ml-2 m-2"
    >
      VER MENOS
    </button>
    <div class="mt-4 border-b-1 border-dark-1"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    limit: 8,
    btnFlag: true,
  }),
  props: {
    specs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showMore() {
      this.btnFlag = false;
      this.limit = 100;
    },
    showLess() {
      this.btnFlag = true;
      this.limit = 8;
    },
  },
  computed: {
    computedSpecs() {
      let result = [];
      if (this.specs === null) {
        return result;
      }

      for (let i in this.specs) {
        this.specs[i].name =
          this.specs[i].name.charAt(0).toUpperCase() +
          this.specs[i].name.substr(1);

        result.push(this.specs[i]);
      }
      result = _.orderBy(result, ["name"], ["asc"]);
      return result.length < this.limit ? result : result.slice(0, this.limit);
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-cx {
  display: grid;
  grid-template-columns: repeat(4, 25%);

  @media screen and (max-width: 428px) {
    grid-template-columns: 1fr;
  }
}

.border-b-cx {
  border-bottom: solid 1px #f2f2f3;
}
</style>

